import { Grid, Divider, Checkbox } from "@mui/material";
import { useRecoilState, useRecoilValue } from "recoil";
import { useEffect } from "react";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  AlertTitleWrapper,
  CheckboxWrapper,
  CheckboxLabelWrapper,
  PatientInfoAlert,
} from "./NewRequisition.styles";
import {
  currentNewRequisition,
  currentNewRequisitionEdit,
} from "../../recoil/atoms";
import { NewRequisitionForm } from "../../recoil/types";

import PatientInformationBasic from "./NewReqPatientInformationBasic";
import PatientInformationAddress from "./NewReqPatientInformationAddress";
import PatientInformationEthnicity from "./NewReqPatientInformationEthnicity";
import PatientInformationFamilyHistory from "./NewReqPatientInformationFamilyHistory";
import { useMirrorRequisitionToCreateOrderState } from "./useMirrorRequisitionToCreateOrderState";
import { getPatientPregnancyNormalizationUpdates } from "./helpers";
import { patientSectionDividerSx } from "./testPanelStyles";

const PatientInformation: React.FC<{
  preflight: boolean;
  isError?: boolean;
  isDraftError?: boolean;
  submittedRequisition?: NewRequisitionForm;
  isEditMode?: boolean;
}> = ({
  preflight = false,
  submittedRequisition,
  isError,
  isDraftError,
  isEditMode = false,
}) => {
  const newGlobalRequisition = useRecoilValue(currentNewRequisition);

  const [newRequisition, setNewRequisition] = useRecoilState(
    currentNewRequisitionEdit,
  );
  useEffect(() => {
    setNewRequisition({
      preflight,
      isError,
      isDraftError,
      requisitionForm: submittedRequisition || newGlobalRequisition,
    });
  }, [isError, preflight, isDraftError]);
  const { requisitionForm } = newRequisition;

  useMirrorRequisitionToCreateOrderState({
    enabled: !preflight && !isEditMode,
    requisitionForm,
  });

  useEffect(() => {
    const updates = getPatientPregnancyNormalizationUpdates(requisitionForm);
    if (!Object.keys(updates).length) return;
    setNewRequisition((currentRequisition) => ({
      ...currentRequisition,
      requisitionForm: {
        ...currentRequisition.requisitionForm,
        ...updates,
      },
    }));
  }, [requisitionForm, setNewRequisition]);

  const onChangeCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewRequisition({
      ...newRequisition,
      requisitionForm: {
        ...newRequisition.requisitionForm,
        [e.target.name]: e.target.checked,
      },
    });
  };

  return (
    <>
      {false && (
        <Grid item xs={12}>
          <Grid
            sx={{
              px: 1,
              pb: 1,
              height: 64,
            }}
          >
            <CheckboxWrapper
              control={
                <Checkbox
                  value={requisitionForm.patientSheetAttached}
                  name="patientSheetAttached"
                  onChange={onChangeCheckBox}
                />
              }
              label={GetTypographyContent({
                content: "I will attach printed Patient information sheet",
                size: "medium",
                textColor: "greyMedium",
              })}
            />
          </Grid>
        </Grid>
      )}
      <PatientInformationBasic isEditMode={isEditMode} />
      <Divider sx={patientSectionDividerSx} />
      <PatientInformationAddress />
      <Divider sx={patientSectionDividerSx} />
      <PatientInformationEthnicity />
      <PatientInformationFamilyHistory />
      <Divider sx={{ ...patientSectionDividerSx, my: 3, mb: 4 }} />
      {
        // hiding for now
        !preflight && false && (
          <PatientInfoAlert icon={false} $isError={false}>
            <AlertTitleWrapper>
              {GetTypographyContent({
                content: "Patient Acknowledgement",
                size: "xlarge",
                textColor: "black",
                isBold: true,
              })}
            </AlertTitleWrapper>
            {GetTypographyContent({
              content:
                "The patient has verbally agreed to the release to BillionToOne of any medical and insurance information necessary to process claims for services provided by BillionToOne. I hereby authorize BillionToOne to pursue all necessary appeals of full or partial denials of payment in relation to services provided by BillionToOne.",
              size: "medium",
              textColor: "greyMedium",
            })}
            {/* <br /> */}
            <CheckboxLabelWrapper
              control={
                <Checkbox
                  id="new-test-patient-ack"
                  checked={requisitionForm.patientAcknowledgement}
                  name="patientAcknowledgement"
                  onChange={onChangeCheckBox}
                />
              }
              label={GetTypographyContent({
                content: "I agree",
                size: "medium",
                textColor: "greyMedium",
              })}
            />
          </PatientInfoAlert>
        )
      }
    </>
  );
};
export default PatientInformation;
